"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const zustandStore_1 = require("../../../../zustandStore");
const slices_1 = require("../../../../zustandStore/slices");
const lexico = new lexico_1.default();
const sortOptionsWithLabels = {
    newest: lexico.trc('Button label', 'Newest'),
    oldest: lexico.trc('Button label', 'Oldest'),
    spendLimit: lexico.trc('Button label', 'Spend limit'),
};
const SortWallet = () => {
    const { sortValue, setWalletSortValue, setCurrentWalletPage, setAreFiltersManuallySet } = (0, zustandStore_1.useZustand)(state => ({
        sortValue: state.wallet.sortValue,
        setAreFiltersManuallySet: state.setAreFiltersManuallySet,
        setWalletSortValue: state.setWalletSortValue,
        setCurrentWalletPage: state.setCurrentWalletPage,
    }));
    const [currentSortKey] = Object.keys(sortValue);
    return ((0, jsx_runtime_1.jsx)(material_1.FormControl, { variant: "outlined", size: "small", style: { padding: 0 }, children: (0, jsx_runtime_1.jsx)(material_1.Select, { "data-testid": "sort-wallet", labelId: "sort-select-label", id: "sort-select", value: currentSortKey || 'newest', onChange: event => {
                setAreFiltersManuallySet(true);
                setCurrentWalletPage(0);
                const selectedOption = event.target.value;
                const newSortValue = { [selectedOption]: slices_1.sortWalletOptions[selectedOption] };
                setWalletSortValue(newSortValue);
            }, label: "Sort", sx: { minWidth: 150 }, renderValue: selected => `Sort: ${sortOptionsWithLabels[selected]}`, children: Object.entries(slices_1.sortWalletOptions).map(([key]) => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: key, children: sortOptionsWithLabels[key] }, key))) }) }));
};
exports.default = SortWallet;
